import { IonIcon } from "@ionic/react";
import { chevronForwardOutline } from "ionicons/icons";

type Tone = "action" | "waiting" | "neutral";

type TodayActionItemProps = {
  title: string;
  hint?: string;
  /**
   * `action` = the ball is in the employee's court and there is a deadline attached; `waiting` =
   * they did their part and something is pending; `neutral` = informational.
   */
  tone?: Tone;
  onClick: () => void;
};

const TONE_STYLES: Record<Tone, { container: string; dot: string }> = {
  action: { container: "border-error-100 bg-error-100/10", dot: "bg-error-100" },
  waiting: { container: "border-warning-100 bg-warning-100/10", dot: "bg-warning-100" },
  neutral: { container: "border-bordercolor-primary bg-surface-primary", dot: "bg-txt-tertiary" },
};

/**
 * One row in the "er wacht iets op jou" strip. Deliberately a plain row and not a card: these are
 * pointers to work, not the work itself, and giving them card weight would put them in competition
 * with the shift above.
 */
export function TodayActionItem({ title, hint, tone = "neutral", onClick }: TodayActionItemProps) {
  const styles = TONE_STYLES[tone];

  return (
    <button
      type="button"
      onClick={onClick}
      className={`flex w-full items-center gap-3 rounded-xl border border-solid px-4 py-3 text-left transition-opacity active:opacity-70 ${styles.container}`}
    >
      <span className={`size-2 shrink-0 rounded-full ${styles.dot}`} />
      <span className="flex flex-1 flex-col">
        <span className="text-md font-semibold leading-[1.4] text-txt-primary">{title}</span>
        {hint && <span className="text-sm leading-[1.4] text-txt-tertiary">{hint}</span>}
      </span>
      <IonIcon icon={chevronForwardOutline} className="size-5 shrink-0 text-txt-tertiary" />
    </button>
  );
}
